"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Edit_1 = __importDefault(require("@material-ui/icons/Edit"));
const Videocam_1 = __importDefault(require("@material-ui/icons/Videocam"));
const AddPhotoAlternate_1 = __importDefault(require("@material-ui/icons/AddPhotoAlternate"));
const Mic_1 = __importDefault(require("@material-ui/icons/Mic"));
const LocationOn_1 = __importDefault(require("@material-ui/icons/LocationOn"));
const theme_1 = require("../../styles/theme");
const lodash_1 = __importDefault(require("lodash"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const styles = {
    folderIcon: {
        height: 20,
        width: 20,
        color: theme_1.colors.black54,
    },
    barcodeIcon: {
        height: 16,
        width: 16,
        color: theme_1.colors.black54,
    },
};
const Icons = {
    fileupload: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faFolder, style: styles.folderIcon }),
    imageupload: react_1.default.createElement(AddPhotoAlternate_1.default, null),
    videoupload: react_1.default.createElement(Videocam_1.default, null),
    audioupload: react_1.default.createElement(Mic_1.default, null),
    barcode: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faBarcodeRead, style: styles.barcodeIcon }),
    signature: react_1.default.createElement(Edit_1.default, null),
    location: react_1.default.createElement(LocationOn_1.default, null),
    aggregateSelector: react_1.default.createElement(LocationOn_1.default, null),
};
const getIcon = (type) => {
    return Icons[type] || null;
};
const createLabel = {
    fileupload: 'File',
    imageupload: 'Image',
    videoupload: 'Video',
    audioupload: 'Audio',
    barcode: 'Barcode',
    signature: 'Signature',
    location: 'Location',
    aggregateSelector: 'Item',
};
const EditComponentButtonWeb = props => {
    const { mode, type, onClick, readOnly, label, translateFunction = text => text } = props;
    const isTypeCheck = lodash_1.default.isEqual(createLabel[type], 'Barcode');
    const classes = useStyles({ isTypeCheck });
    return (react_1.default.createElement(core_1.TextField, { placeholder: translateFunction(label) || translateFunction('$__MODE__$ $__TYPE__$', { MODE: lodash_1.default.capitalize(mode), TYPE: createLabel[type] }), variant: "outlined", className: classes.textField, onClick: onClick, InputProps: {
            startAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "start", className: "start" }, getIcon(type))),
            endAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "8", height: "13", viewBox: "0 0 8 13", fill: "none" },
                    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 1.5L1.5 0L8 6.5L1.5 13L0 11.5L5 6.5L0 1.5Z", fill: "#AAAAAA" })))),
            readOnly: true,
            disabled: readOnly,
        } }));
};
const useStyles = (0, core_1.makeStyles)(() => (0, core_1.createStyles)({
    textField: {
        width: '100%',
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                border: `1px solid ${theme_1.colors.black10}`,
                borderRadius: 5,
            },
            '&:hover fieldset': {
                borderColor: `${theme_1.colors.black10} !important`,
            },
            '&.Mui-focused fieldset': {
                borderColor: `${theme_1.colors.black10} !important`,
            },
            '&.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                border: `1px solid ${theme_1.colors.black10}`,
                borderRadius: 5,
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: 8,
            paddingLeft: 2,
            cursor: 'pointer',
            '&::placeholder': {
                color: theme_1.colors.black54,
                opacity: 1,
                fontSize: 14,
                fontFamily: 'Roboto',
                fontWeight: 400,
                lineHeight: 'normal',
            },
        },
        '& .start': {
            '& svg': {
                height: '20px',
                width: '20px',
                color: theme_1.colors.black54,
            },
        },
        '& .MuiOutlinedInput-adornedEnd': {
            paddingRight: 12,
            cursor: 'pointer',
        },
        '& .MuiOutlinedInput-adornedStart': {
            paddingLeft: 12,
        },
    },
    root: (props) => ({
        marginTop: props.isTypeCheck ? 0 : 10,
    }),
}));
exports.default = EditComponentButtonWeb;
//# sourceMappingURL=EditComponentButtonWeb.js.map